import React from 'react';
import { connect } from 'react-redux';
import actions from 'actions';
import constants from 'constants';
import classNames from 'classnames';

const {
  setProfileConfirmation
} = actions;

const {
  ZOOM_INFO_STATUS
} = constants;

function ZoomInfo({
  modalStatus,
  setProfileConfirmation
}) {

  const hide = () => {
    setProfileConfirmation(ZOOM_INFO_STATUS.hideInProgress);
    setTimeout(() => {
      setProfileConfirmation(ZOOM_INFO_STATUS.closed)
    }, 1000);
  }

  let className = 'hide';
  switch (modalStatus) {
    case ZOOM_INFO_STATUS.open:
      className = 'open';
      break;
    case ZOOM_INFO_STATUS.hideInProgress:
      className = 'hide'
      break;
    case ZOOM_INFO_STATUS.closed:
      className = 'hide'
      break;
  }

  return (
    <div className={classNames('zoom_gradient', className)}>
      <div className="bg_zoom_icon">
        <div className="container_dash_zoom">
          <div className="container_zoom_logo">
            <img
              className="logo_zoom"
              src="/assets/img/zoom_mobile.png"
              alt="logo"
            />
          </div>
          <div className="container_title_zoom">
            <p className="title_zoom">
              Webinars on MedCafe.ie are run via Zoom technology. Please
              click on the appropriate icon below download the Zoom app if
              you have not yet done so already:
            </p>
            <p className="title_zoom_desctop">
              Webinars on MedCafe.ie are run via Zoom technology.
            </p>
            <p className="title_zoom_desctop">
              Please download Zoom if you have not yet done so already:
            </p>
          </div>

          <div className="zoom_app">
            <a className="zoom_app_link" target="_blank" href="https://itunes.apple.com/app/zoom-cloud-meetings/id546505307?mt=8">
              <img
                className=""
                src="/assets/img/apple.png"
                alt="logo"
              />
            </a>
            <a className="zoom_app_link" target="_blank" href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings">
              <img
                className=""
                src="/assets/img/android.png"
                alt="logo"
              />
            </a>
          </div>
          <a className="zoom_download" target="_blank" href="https://zoom.us/download" download>
            <img
              className=""
              src="/assets/img/download_zoom.png"
              alt="logo"
            />
          </a>
          <a onClick={hide} className="close_zoom" href="javascript:void(0)">
            <img src="/assets/img/close-zoom.png" alt="close" />
          </a>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(store) {
  return {
    modalStatus: store.users.showProfileConfirmation
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setProfileConfirmation: (status) => dispatch(setProfileConfirmation(status))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ZoomInfo
);



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/ZoomInfo.jsx
 **/